module.exports = "<tb-set-mfa></tb-set-mfa>\n";